module.exports = __webpack_public_path__ + "img/staffEval.d3ddbb87.svg";